import { ITranslations } from 'types/common';
import { ProductRequestFormTransFields } from './types';
import en from 'translations/en/productRequestForm.json';
import pl from 'translations/pl/productRequestForm.json';
import sl from 'translations/sl/productRequestForm.json';

export const productRequestFormTranslations: ITranslations<ProductRequestFormTransFields> = {
  name: 'productRequestForm',
  en,
  pl,
  sl,
};
